import { Group, Panel } from 'react-resizable-panels';
import { joinClasses } from 'utils/componentStyles/style.utils';
import { ResizablePanelHandle } from 'utils/layout/panelResize.utils';
import {
  getWeatherMapPanelAxisClass,
  getWeatherMapResizeHandleDirection,
} from '../../../../utils/weatherMapLayout.utils';

const ResizableWeatherMapLayout = ({
  orientation,
  mapContent,
  panelContent,
  mapDefaultSize,
  panelDefaultSize,
  mapMinSize,
  panelMinSize,
  mapAriaLabel,
  panelAriaLabel,
  resizeHandleAriaLabel,
  containerClassName,
  mapClassName,
  panelClassName,
}) => {
  const panelAxisClass = getWeatherMapPanelAxisClass(orientation);

  return (
    <Group
      className={joinClasses(
        'weather-map-resizable-layout h-100 w-100 min-h-0 min-w-0',
        containerClassName,
      )}
      data-resizable="true"
      data-weather-map-layout={orientation}
      orientation={orientation}
    >
      <Panel
        aria-label={mapAriaLabel}
        className={joinClasses(
          'd-flex min-h-0 min-w-0 flex-column overflow-hidden',
          panelAxisClass,
          mapClassName,
        )}
        defaultSize={mapDefaultSize}
        minSize={mapMinSize}
        role="region"
      >
        {mapContent}
      </Panel>

      <ResizablePanelHandle
        aria-label={resizeHandleAriaLabel}
        direction={getWeatherMapResizeHandleDirection(orientation)}
      />

      <Panel
        aria-label={panelAriaLabel}
        className={joinClasses(
          'd-flex min-h-0 min-w-0 flex-column overflow-auto',
          panelAxisClass,
          panelClassName,
        )}
        defaultSize={panelDefaultSize}
        minSize={panelMinSize}
        role="complementary"
      >
        {panelContent}
      </Panel>
    </Group>
  );
};

export default ResizableWeatherMapLayout;
